import { render, staticRenderFns } from "./Giftbag.vue?vue&type=template&id=3f6c1802&scoped=true&"
import script from "./Giftbag.vue?vue&type=script&lang=js&"
export * from "./Giftbag.vue?vue&type=script&lang=js&"
import style0 from "./Giftbag.vue?vue&type=style&index=0&id=3f6c1802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c1802",
  null
  
)

export default component.exports